module.exports = __webpack_public_path__ + "media/static/logoDevbot-white-269cd2b5642ab525d9179e03b28e9f02.png";